import { render, staticRenderFns } from "./H1.vue?vue&type=template&id=cc6d6694&"
import script from "./H1.vue?vue&type=script&lang=js&"
export * from "./H1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports